import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const CheckIcon: FC<IconProps> = ({ size = 20, color = '#E7E7EA' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M16.8687 5.21466C17.2104 5.55636 17.2104 6.11038 16.8687 6.45209L8.53539 14.7854C8.19368 15.1271 7.63966 15.1271 7.29795 14.7854L3.13128 10.6188C2.78957 10.2771 2.78957 9.72303 3.13128 9.38132C3.47299 9.03961 4.02701 9.03961 4.36872 9.38132L7.91667 12.9293L15.6313 5.21466C15.973 4.87295 16.527 4.87295 16.8687 5.21466Z'
          fill={color} />
  </svg>
)

export default CheckIcon
